import { types } from "../types/types";

const initialState = {
    archivos: null,
    novedades: null,
    parametrosImportacion: null,
    loading: false
};

export const ArchivosMigracionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.archivosMigracionTraer:
            return {
                ...state,
                loading: true
            }
        case types.archivosMigracionSuccess:
            return {
                ...state,
                archivos: action.payload,
                loading: false
            }
        case types.novedadesSuccess:
            return {
                ...state,
                novedades: action.payload,
                loading: false
            }
        case types.archivosMigracionError:
            return {
                ...state,
                archivos: [],
                loading: false
            }
        case types.parametrosImportacionTraer:
            return {
                ...state,
                loading: true
            }
        case types.parametrosImportacionSuccess:
            return {
                ...state,
                parametrosImportacion: action.payload,
                loading: false
            }
        case types.parametrosImportacionError:
            return {
                ...state,
                parametrosImportacion: [],
                loading: false
            }
        default:
            return state;
    }
};
